<!-- eslint-disable vue/no-v-model-argument -->
<template>
  <v-main>
    <v-container fluid>
      <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
      <v-card>
        <v-card-title>
          Artikel
          <v-spacer></v-spacer>
          <v-btn color="primary" dark class="mb-2" @click="goToAdd">
            Tambah
          </v-btn>
        </v-card-title>

        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
            <v-card-title class="text-h5"
              >Apa anda akan menghapus data ini?</v-card-title
            >
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeDelete"
                >Tidak</v-btn
              >
              <v-btn color="blue darken-1" text @click="deleteItemConfirm"
                >Ya</v-btn
              >
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-row class="mx-4 my-4">
          <v-col cols="12" sm="4">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Cari Judul"
              single-line
              outlined
              dense
              hide-details
              @keyup.enter="getDataFromApi"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4">
            <v-combobox
              v-model="filterKategori"
              label="Kategori"
              clearable
              dense
              outlined
              :items="items_kategori"
              item-text="nama"
              @update:model-value="getDataFromApi"
            ></v-combobox>
          </v-col>
        </v-row>

        <v-data-table
          :options.sync="options"
          :headers="headers"
          :items="list_data"
          :server-items-length="totalData"
          :loading="loading"
          class="elevation-1"
        >
          <template #[`item.actions`]="{ item }">
            <v-icon medium class="mr-3" @click="editItem(item)">
              mdi-pencil
            </v-icon>
            <v-icon medium @click="deleteItem(item)"> mdi-delete </v-icon>
          </template>
          <template #[`item.created_at`]="{ item }">
            <span>{{ getCurrentDate(item.created_at) }}</span>
          </template>
          <template #[`item.data_status`]="{ item }">
            <v-chip :color="getColor(item.data_status)" dark>
              {{ getIsHide(item.data_status) }}
            </v-chip>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </v-main>
</template>

<script setup>
import { ref, onMounted, watch } from "vue";
import { useRouter } from "../../utils/utils.js";
import ArtikelService from "../../services/web_content/ArtikelService";
import KategoriArtikelService from "../../services/web_content/KategoriArtikelService";
import CommonService from "../../services/CommonService";
import moment from "moment";

const router = useRouter();

// --- Static Data ---
const breadcrumbs = [
  {
    text: "Data Artikel",
    disabled: true,
    href: "breadcrumbs_dashboard",
  },
];

const headers = [
  { text: "No", value: "no", sortable: false },
  { text: "Judul", value: "title", sortable: false },
  { text: "Kategori", value: "article_type_nama", sortable: false },
  { text: "Tanggal", value: "created_at", sortable: false },
  { text: "Published", value: "data_status", sortable: false },
  { text: "Actions", value: "actions", sortable: false },
];

// --- Reactive State ---
const search = ref("");
const filterKategori = ref(null);
const items_kategori = ref([]);
const list_data = ref([]);
const totalData = ref(0);
const loading = ref(true);
const options = ref({ itemsPerPage: 5 });
const isFirstLoad = ref(true); // Flag to prevent initial watcher trigger

const dialogDelete = ref(false);
const editedItem = ref({});

// --- Functions ---
const getIsHide = (dataStatus) => (dataStatus === 1 ? "On" : "Off");

const getColor = (dataStatus) => (dataStatus === 1 ? "cyan" : "red");

const getCurrentDate = (tanggal) => moment(tanggal).format("DD/MM/YYYY");

const getListKategori = async () => {
  try {
    const res = await KategoriArtikelService.kategoriArtikelListAll();
    items_kategori.value = res.data.list_data;
  } catch (err) {
    console.error(err);
  }
};

const getDataFromApi = async () => {
  loading.value = true;
  try {
    const { page, itemsPerPage } = options.value;
    const kategoriId = filterKategori.value ? filterKategori.value.id : "";
    const res = await ArtikelService.artikelList(
      page,
      itemsPerPage,
      search.value,
      kategoriId,
    );
    list_data.value = res.data.list_data;
    totalData.value = res.data.total;
  } catch (err) {
    console.error(err);
  } finally {
    loading.value = false;
    isFirstLoad.value = false; // Allow watcher to run after first load
  }
};

const goToAdd = () => {
  router.push("/webcontent/artikel/add");
};

const editItem = (item) => {
  sessionStorage.setItem("item_artikel", JSON.stringify(item));
  router.push(`/webcontent/artikel/edit/${item.id}`);
};

const deleteItem = (item) => {
  editedItem.value = { ...item };
  dialogDelete.value = true;
};

const deleteItemConfirm = async () => {
  try {
    await ArtikelService.delete(editedItem.value.id);
    CommonService.showSuccessToast("Hapus artikel berhasil");
    getDataFromApi();
  } catch (err) {
    console.error(err);
    CommonService.showErrorToast("Hapus artikel gagal. Coba lagi");
  }
  closeDelete();
};

const closeDelete = () => {
  dialogDelete.value = false;
  editedItem.value = {};
};

// --- Watchers & Lifecycle Hooks ---
watch(
  options,
  () => {
    // Avoid running on the initial component mount
    if (!isFirstLoad.value) {
      getDataFromApi();
    }
  },
  { deep: true },
);

onMounted(() => {
  getListKategori();
  getDataFromApi();
});
</script>
